import { OrientableFloorPlanElement } from "./orientableFloorPlanElement";
import Icon from "../../../../../assets/img/icon-entrance.svg";
import { Entrance } from "../../../../../types/FloorPlan/Entrance.types";

export class EntranceElement extends OrientableFloorPlanElement {
    constructor(entrance: Entrance) {
        super("Entrance", entrance.x, entrance.y, entrance.mapRefUUID, entrance.orientation, Icon, true)
    }
}